import i18n from "../../../../../i18n";
import { createLoading } from "../../../../../utils/loading";
import { createPage, createManageDelete, createManageExportCsv } from "../../../../../utils/page";
import { onClickDeleteAllClient } from "../../../../../utils/form";
import { createColumnInput } from "../../../../../components/table/c-table.logic";
import { has } from "../../../../../utils/menu-context";
import { openModalList as openModalListUser } from "../user/user.logic";
import { openModalList as openModalListRole } from "../role/role.logic";
import { onIFrameClickSelectAll } from "../../../../../utils/iframe";
import { createButtonCreate } from "../../../../../utils/button";
import store from "../../../../../store";
import lodash from "lodash";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/security/userRole";
export const routerPrefix = "user-roles";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = ({ props }) => {
    const { visibleUser, visibleRole } = props;
    const columns = [];
    if (visibleUser) {
        columns.push(createColumnInput({ title: () => i18n.global.t("model.user.username"), dataIndex: "refUser.username", align: "center" }));
        columns.push(createColumnInput({ title: () => i18n.global.t("model.user.fullNameTh"), dataIndex: "refUser.fullNameTh", width: 200 }));
    }
    if (visibleRole) {
        columns.push(createColumnInput({ title: () => i18n.global.t("model.role.name"), dataIndex: "refRole.name", align: "center" }));
        columns.push(createColumnInput({ title: () => i18n.global.t("model.role.desc"), dataIndex: "refRole.desc", width: 200 }));
    }
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visibleUser, visibleRole } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : has({ menuContext, key: "canDelete" })),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [];
    data.rowActions = [];

    if (!viewOnly) {
        if (visibleUser) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () =>
                            openModalListUser({
                                onIframeMounted: ({ refs, options }) =>
                                    onIFrameClickSelectAll({
                                        refs,
                                        options,
                                        items,
                                        itemKey: "refUser.id",
                                        rowKey: "id",
                                        setKey: "refUser"
                                    })
                            }),
                        options: { text: i18n.global.t("model.user.modelName") }
                    })
                }),
                visible: () => has({ menuContext, key: "canCreate" })
            });
        }
        if (visibleRole) {
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () =>
                            openModalListRole({
                                onIframeMounted: ({ refs, options }) =>
                                    onIFrameClickSelectAll({
                                        refs,
                                        options,
                                        items,
                                        itemKey: "refRole.id",
                                        rowKey: "id",
                                        setKey: "refRole"
                                    })
                            }),
                        options: { text: i18n.global.t("model.user.modelName") }
                    })
                }),
                visible: () => has({ menuContext, key: "canCreate" })
            });
        }
    }

    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
